import React, { useState, useEffect } from 'react'
import { Row, Col, Button } from 'react-bootstrap';
import {  useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom';
import { LinkContainer } from 'react-router-bootstrap';
import StudentHeader from '../../components/StudentHeader';
import StudentNavbar from '../../components/StudentNavbar';
import Loader from '../../components/Loader';
import Message from '../../components/Message';
import Subject from '../../components/Subject';

const StudentAskType = () => {
    
    const { id } = useParams();

    const navigate = useNavigate();

    const { studentInfo } = useSelector((state) => state.authStudent);

    useEffect(() => {
        if(!studentInfo) {
            navigate('/studentlogin')
        }
    }, [navigate, studentInfo])

  return (
    <div>
        <StudentNavbar />
        <div className="main-content" id="panel">
            <StudentHeader /><br /><br /><br /><br />
            <div className="container-fluid mt--6">
                <div className="row"><br />
                <h4 className="centerTitle tittleColor4 ">
                        <span className='tittleColor4'>Upload a video or record your question</span>
                        </h4><br /><br />
                    <div className="col-lg-4 ">   
                        <LinkContainer to={`/studentupload/${id}`} >
                            <div className="card bg-gradient-warning">
                                <div className="card-body mouseP">
                                    <div className="row">
                                        <div className="col"><br />
                                            <span className="h2 font-weight-bold mb-0 text-white">Upload new video </span>
                                        </div>
                                        <div className="col-auto">
                                        <div className="icon icon-shape bg-white text-dark rounded-circle shadow">
                                            <i className="ni ni-atom"></i>
                                        </div>
                                        </div>
                                    </div>
                                    <p className="mt-3 mb-0 text-sm"><br />
                                    <span className="text-white mr-2"><i className="fa fa-arrow-up"></i> Upload up to a 5 minutes question</span>
                                    </p>
                                </div>
                            </div>
                        </LinkContainer>  
                    </div>
                    <div className="col-lg-4 "> 
                        <LinkContainer to={`/studentscreen/${id}`} >  
                            <div className="card bg-gradient-info">
                            <div className="card-body mouseP">
                            <div className="row">
                                <div className="col"><br />
                                <span className="h2 font-weight-bold mb-0 text-white ">Record PC screen</span>
                                </div>
                                <div className="col-auto">
                                <div className="icon icon-shape bg-white text-dark rounded-circle shadow">
                                    <i className="ni ni-active-40"></i>
                                </div>
                                </div>
                            </div>
                            <p className="mt-3 mb-0 text-sm"><br />
                            <span className="text-white mr-2"><i className="fa fa-arrow-up"></i> Record up to a 5 minutes question</span>
                            </p>
                            </div>
                            </div>
                        </LinkContainer>  
                    </div>
                    <div className="col-lg-4">   
                        <LinkContainer to={`/studentcamera/${id}`} >
                            <div className="card bg-gradient-primary">
                                <div className="card-body mouseP">
                                <div className="row">
                                    <div className="col"><br />                        
                                    <span className="h2 font-weight-bold mb-0 text-white">Record Camera</span>
                                    </div>
                                    <div className="col-auto">
                                    <div className="icon icon-shape bg-white text-dark rounded-circle shadow">
                                        <i className="ni ni-spaceship"></i>
                                    </div>
                                    </div>
                                </div>
                                <p className="mt-3 mb-0 text-sm"><br />
                                <span className="text-white mr-2"><i className="fa fa-arrow-up"></i> Record up to a 5 minutes question</span>
                                </p>
                                </div>
                            </div>
                        </LinkContainer>  
                    </div>     



                    {/* <div className="col-xl-4 ">   
                        <LinkContainer to={`/studentupload/${id}`} >
                            <div className="card bg-gradient-default">
                                <div className="card-body mouseP">
                                    <div className="row">
                                        <div className="col"><br />
                                            <span className="h2 font-weight-bold mb-0 text-white">Upload new video </span>
                                        </div>
                                        <div className="col-auto">
                                        <div className="icon icon-shape bg-white text-dark rounded-circle shadow">
                                            <i className="ni ni-atom"></i>
                                        </div>
                                        </div>
                                    </div>
                                    <p className="mt-3 mb-0 text-sm"><br />
                                    <span className="text-white mr-2"><i className="fa fa-arrow-up"></i> Upload up to a 5 minutes question</span>
                                    </p>
                                </div>
                            </div>
                        </LinkContainer>  
                    </div>
                    <div className="col-xl-4 "> 
                        <LinkContainer to={`/studentscreen/${id}`} >  
                            <div className="card bg-gradient-danger">
                            <div className="card-body mouseP">
                            <div className="row">
                                <div className="col"><br />
                                <span className="h2 font-weight-bold mb-0 text-white ">Record PC screen</span>
                                </div>
                                <div className="col-auto">
                                <div className="icon icon-shape bg-white text-dark rounded-circle shadow">
                                    <i className="ni ni-active-40"></i>
                                </div>
                                </div>
                            </div>
                            <p className="mt-3 mb-0 text-sm"><br />
                            <span className="text-white mr-2"><i className="fa fa-arrow-up"></i> Record up to a 5 minutes question</span>
                            </p>
                            </div>
                            </div>
                        </LinkContainer>  
                    </div>
                     */}







                </div>  
            </div>
        </div>
    </div>
  )
}

export default StudentAskType
